import { FileText } from "lucide-react";
import React from "react";

import { cn } from "@/app/handlers/cn.utils";

interface DSP {
	dsp_id: string;
	dsp_title: string;
	dsp_description: string;
	source_resume: {
		doc_id: string;
		file_name: string;
		storage_key: string;
	};
}

interface DSPItemProps {
	dsp: DSP;
	isSelected: boolean;
	onSelect: () => void;
}

export const DSPItem = ({ dsp, isSelected, onSelect }: DSPItemProps) => {
	return (
		<div
			onClick={onSelect}
			className={cn(
				"flex items-start gap-3 p-4 bg-white rounded-lg border transition-all cursor-pointer",
				isSelected ? "border-blue-600" : "border-gray-200 hover:border-gray-300",
			)}
		>
			<div className="flex-1 min-w-0">
				<p className="font-bold text-base text-gray-900">{dsp.dsp_title}</p>
				<p className="text-sm text-gray-700 font-medium mt-0.5">{dsp.dsp_description}</p>
				<div className="flex items-center gap-1.5 text-xs text-gray-500">
					<FileText className="w-3 h-3" />
					<span>Resume: {dsp.source_resume.file_name}</span>
				</div>
			</div>
			<div
				className={cn(
					"w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0 transition-all",
					isSelected ? "border-blue-600" : "border-gray-300",
				)}
			>
				{isSelected && <div className="w-2.5 h-2.5 rounded-full bg-blue-600" />}
			</div>
		</div>
	);
};

export default DSPItem;
